'use client';

import { motion } from 'motion/react';
import { useState } from 'react';

import { useHorizontalScrollAttempt } from '~/lib/hooks/useHorizontalScrollAttempt';

const ANIMATION_DURATION = 1.8;

const ScrollDirectionNotifier = () => {
  const [key, setKey] = useState<number | null>(null);

  useHorizontalScrollAttempt({
    threshold: 10,
    attemptDeps: [key],

    onAttempt() {
      if (key === null) {
        setKey(Date.now());
      }
    },
  });

  if (!key) {
    return null;
  }

  return (
    <div className="fixed bottom-18 left-0 z-40 px-10 py-5 max-lg:hidden!">
      <motion.div
        key={key}
        className="bg-brand-tertiary/80 border-brand-tertiary relative flex flex-row items-center gap-4 border px-4 py-3 backdrop-blur-md"
        animate={{ opacity: [0, 1, 1, 0], scale: [0.9, 1, 1, 0.9] }}
        transition={{
          opacity: {
            duration: ANIMATION_DURATION * 4,
            times: [0, 0.05, 0.95, 1],
            ease: 'easeInOut',
          },

          scale: {
            duration: ANIMATION_DURATION * 4,
            times: [0, 0.1, 0.8, 1],
            ease: 'easeInOut',
          },
        }}
        onAnimationComplete={() => setKey(null)}
      >
        <div className="border-brand-quinary bg-brand-quaternary relative flex h-14 w-11 items-center justify-center rounded-4xl border py-3 backdrop-blur-md">
          <motion.div
            className="relative h-2 w-2 rounded-full border border-white bg-white/25"
            animate={{
              y: [-10, 10, 10, -10],
            }}
            transition={{
              y: {
                duration: ANIMATION_DURATION,
                times: [0, 0.75, 1],
                ease: 'circInOut',
                repeat: Infinity,
              },
            }}
          />
        </div>

        <p className="text-brand-quaternary text-xl tracking-tight whitespace-nowrap select-none">
          Naviguez verticalement
        </p>
      </motion.div>
    </div>
  );
};

export default ScrollDirectionNotifier;
